export const getCourse = /* GraphQL */ `
  query GetCourse(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    getCourse(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
      schemaVersion
      workspaceId
      bankId
      alignmentScopes
      createdAt
      coverImage {
        key
        bucket
        region
      }
      creator {
        id
        sk
        firstName
        lastName
      }
      creatorId
      description
      duration
      grade
      maturity
      name
      notes
      resourcesIds {
        id
      }
      subject
      tags {
        key
        type
        value
      }
      unitIds {
        id
        sk
        tags {
          key
          type
          value
        }
      }
      updatedAt
    }
  }
`;

export const getCourseWithUnits = /* GraphQL */ `
  query GetCourseWithUnits(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getCourse(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
      schemaVersion
      workspaceId
      name
      subject
      alignmentScopes
      coverImage {
        key
        bucket
        region
      }
      units {
        id
        sk
        unit {
          id
          sk
          workspaceId
          schemaVersion
          name
          numberLabel
          tags {
            key
            type
            value
          }
        }
        tags {
          key
          type
          value
        }
      }
    }
  }
`;

export const getCourseWithUnitsAndUnitIds = /* GraphQL */ `
  query GetCourseWithUnitsAndUnitIds(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getCourse(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
      schemaVersion
      workspaceId
      bankId
      alignmentScopes
      createdAt
      creator {
        id
        sk
        firstName
        lastName
      }
      creatorId
      description
      duration
      grade
      maturity
      name
      notes
      resourcesIds {
        id
      }
      subject
      tags {
        key
        type
        value
      }
      units {
        id
        sk
        unit {
          id
          sk
          workspaceId
          schemaVersion
          name
          numberLabel
          tags {
            key
            type
            value
          }
        }
        tags {
          key
          type
          value
        }
      }
      unitIds {
        id
        sk
        tags {
          key
          type
          value
        }
      }
      updatedAt
    }
  }
`;

export const listUnitLayouts = /* GraphQL */ `
  query ListUnitLayouts(
    $input: ListResourcesByIdThenSkInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    listUnitLayouts(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        sk
        schemaVersion
        workspaceId

        name
        description
        buckets {
          id
          name

          unitIds {
            id
            sk
          }
        }
      }
      nextToken
    }
  }
`;

export const createUnitLayout = /* GraphQL */ `
  mutation CreateUnitLayout(
    $input: CreateUnitLayoutInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    createUnitLayout(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const updateUnitLayout = /* GraphQL */ `
  mutation UpdateUnitLayout(
    $input: UpdateUnitLayoutInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    updateUnitLayout(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const deleteUnitLayout = /* GraphQL */ `
  mutation DeleteUnitLayout(
    $input: DeleteUnitLayoutInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    deleteUnitLayout(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const getCourseVerification = /* GraphQL */ `
  query GetCourseVerification(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getCourse(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
      schemaVersion
      workspaceId
      bankId
      alignmentScopes
      units {
        id
        unit {
          id
          sk
          name
          numberLabel
          objectives {
            id
            sk
            objective {
              id
              sk
              abbreviation
              sequence
            }
            tags {
              key
              type
              value
            }
          }
        }
      }
      createdAt
      grade
      maturity
      name
      notes
      subject
      tags {
        key
        type
        value
      }
      updatedAt
    }
  }
`;
